import React, { useState } from 'react';
import './Interest.css';
import { saveInterestLocally } from '../interestStorage';

const ALLOW_LOCAL_FALLBACK =
  process.env.NODE_ENV !== 'production' ||
  process.env.REACT_APP_ENABLE_LOCAL_INTEREST_FALLBACK === 'true';

const Interest = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    mobileNumber: '',
    comments: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.companyName.trim()) {
      newErrors.companyName = 'Company name is required.';
    }
    if (!formData.contactPerson.trim()) {
      newErrors.contactPerson = 'Contact person is required.';
    }
    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = 'Mobile number is required.';
    } else if (!/^[0-9+\-\s]{7,15}$/.test(formData.mobileNumber.trim())) {
      newErrors.mobileNumber = 'Enter a valid mobile number.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const API_BASE =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_BASE || ''
      : '';

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    setSubmitError('');
    setSubmitting(true);

    // Send data to backend API (MongoDB)
    fetch(`${API_BASE}/api/interest`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((res) => {
        if (!res.ok) {
          if (ALLOW_LOCAL_FALLBACK) {
            saveInterestLocally(formData);
          } else {
            throw new Error('Failed to save to shared server.');
          }
        }

        if (onSubmit) {
          onSubmit(formData);
        }
        setIsSubmitted(true);
      })
      .catch((error) => {
        console.error('Failed to submit interest:', error);
        if (ALLOW_LOCAL_FALLBACK) {
          saveInterestLocally(formData);
          if (onSubmit) {
            onSubmit(formData);
          }
          setIsSubmitted(true);
        } else {
          setSubmitError('Could not submit to the shared server. Please try again later.');
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <section className="interest-page">
      <div className="interest-container">
        <h1>{isSubmitted ? 'Registered Your Interest' : 'Register Your Interest'}</h1>
        {!isSubmitted && (
          <p className="interest-subtitle">
            Submit the details, we will get back with the Demo/Presentation
          </p>
        )}
        {!isSubmitted && submitError && (
          <p className="error-text">{submitError}</p>
        )}
        {isSubmitted ? (
          <>
            <p className="interest-thankyou">
              Thank you for submitting your interest, we will contact you soon.
            </p>
            <button
              type="button"
              className="interest-home-button"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Go to Home
            </button>
          </>
        ) : (
          <form className="interest-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
              />
              {errors.companyName && (
                <span className="error-text">{errors.companyName}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="contactPerson">Contact Person</label>
              <input
                type="text"
                id="contactPerson"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                required
              />
              {errors.contactPerson && (
                <span className="error-text">{errors.contactPerson}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="mobileNumber">Mobile Number</label>
              <input
                type="tel"
                id="mobileNumber"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
              />
              {errors.mobileNumber && (
                <span className="error-text">{errors.mobileNumber}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="comments">Comments (Optional)</label>
              <textarea
                id="comments"
                name="comments"
                rows="3"
                value={formData.comments}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="interest-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default Interest;
